import prettyBytes from 'pretty-bytes';

/**
 * Value less than 1 MB to show in whole numbers KB
 * Value greater than equal to 1MB -> If whole number, show w/o decimal else upto 1 decimal place
 *
 * @param fileSize File size in Bytes
 * @param locale Current locale of the browser getting used in
 *
 */
export function transformFileSize(fileSize: number, locale: string): string {
  const fileInKb = fileSize / 1024;
  const isNumber = Number.isInteger(fileInKb);
  const minFileSize = 976.5;
  if (fileInKb >= minFileSize) {
    return prettyBytes(fileSize, { locale, maximumFractionDigits: isNumber ? 0 : 1 }).toUpperCase();
  } else {
    return `${fileInKb.toFixed(0)} KB`;
  }
}
